import { Component, OnInit } from '@angular/core';
import { SpinnerService } from 'src/app/core/services/spinner.service';

@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.scss']
})
export class LoadingScreenComponent implements OnInit {
  public subscriptions: any[] = <any>[];
  public showLoader: boolean = false;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() {
    this.subscriptions.push(
      this.spinnerService.visibility.subscribe((val: boolean) => {
        setTimeout(() => { this.showLoader = val; }, 0); //fix for expressionchanged error 
      })
    );
  }
  /**
   * On Destroy
   */
  ngOnDestroy() {
    this.subscriptions.forEach(el => el.unsubscribe());
  }
}
